module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"newAssessment":"New Assessment"},"es":{"newAssessment":"VISITA TÉCNICA"},"sw":{"newAssessment":"Tathmini Mpya"}}')
  delete Component.options._Ctor
}
